import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card card-flush mb-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "fw-bolder" }, "Chargeback Details")
  ])
], -1)
const _hoisted_3 = { class: "px-9 mb-5" }
const _hoisted_4 = { class: "d-flex flex-wrap" }
const _hoisted_5 = { class: "flex-equal me-5" }
const _hoisted_6 = { class: "table fs-7 fw-bold gs-0 gy-2 gx-2 m-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", { class: "text-gray-400 min-w-175px w-175px" }, "Chargeback Id:", -1)
const _hoisted_8 = { class: "text-gray-800" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", { class: "text-gray-400" }, "Case Number:", -1)
const _hoisted_10 = { class: "text-gray-800" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", { class: "text-gray-400" }, "Chargeback Amount:", -1)
const _hoisted_12 = { class: "text-gray-800" }
const _hoisted_13 = { class: "fs-8 text-boldest" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", { class: "text-gray-400" }, "Chargeback Date:", -1)
const _hoisted_15 = { class: "text-gray-800" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", { class: "text-gray-400" }, "CC Number:", -1)
const _hoisted_17 = { class: "text-gray-800" }
const _hoisted_18 = { class: "flex-equal" }
const _hoisted_19 = { class: "table fs-7 fw-bold gs-0 gy-2 gx-2 m-0" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", { class: "text-gray-400" }, "Due Date:", -1)
const _hoisted_21 = { class: "text-gray-800" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", { class: "text-gray-400 min-w-175px w-175px" }, "Reason Code:", -1)
const _hoisted_23 = { class: "text-gray-800" }
const _hoisted_24 = {
  class: "text-dark p-0",
  href: "#chargeback_reason_explained",
  "data-bs-toggle": "modal"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", { class: "text-gray-400" }, "Card Brand:", -1)
const _hoisted_26 = { class: "text-gray-800" }
const _hoisted_27 = {
  key: 0,
  src: "/media/svg/card-logos/visa.png",
  alt: "",
  class: "h-20px"
}
const _hoisted_28 = {
  key: 1,
  src: "/media/svg/card-logos/mastercard.png",
  alt: "",
  class: "h-20px"
}
const _hoisted_29 = {
  key: 2,
  src: "/media/svg/card-logos/american-express.png",
  alt: "",
  class: "h-20px"
}
const _hoisted_30 = {
  key: 3,
  src: "/media/svg/card-logos/discovercard.png",
  alt: "",
  class: "h-20px"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", { class: "text-gray-400" }, "Transaction Date:", -1)
const _hoisted_32 = { class: "text-gray-800" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", { class: "text-gray-400" }, "Inserted Date:", -1)
const _hoisted_34 = { class: "text-gray-800" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = /*#__PURE__*/_createStaticVNode("<div class=\"rounded border pt-0 mb-5\"><div class=\"accordion\" id=\"kt_accordion_1\"><div class=\"accordion-item\"><h2 class=\"accordion-header\" id=\"kt_accordion_1_header_1\"><button class=\"accordion-button fs-6 fw-bold\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#kt_accordion_1_body_1\" aria-expanded=\"true\" aria-controls=\"kt_accordion_1_body_1\"> Order Details </button></h2><div id=\"kt_accordion_1_body_1\" class=\"accordion-collapse collapse show\" aria-labelledby=\"kt_accordion_1_header_1\" data-bs-parent=\"#kt_accordion_1\" style=\"\"><div class=\"accordion-body\"><div class=\"mb-0\"><span class=\"fs-7 text-gray-500\">Not Populated</span></div></div></div></div><div class=\"accordion-item\"><h2 class=\"accordion-header\" id=\"kt_accordion_1_header_2\"><button class=\"accordion-button fs-6 fw-bold collapsed\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#kt_accordion_1_body_2\" aria-expanded=\"false\" aria-controls=\"kt_accordion_1_body_2\"> Transaction Details </button></h2><div id=\"kt_accordion_1_body_2\" class=\"accordion-collapse collapse\" aria-labelledby=\"kt_accordion_1_header_2\" data-bs-parent=\"#kt_accordion_1\" style=\"\"><div class=\"accordion-body\"><div class=\"mb-0\"><span class=\"fs-7 text-gray-500\">Not Populated</span></div></div></div></div><div class=\"accordion-item\"><h2 class=\"accordion-header\" id=\"kt_accordion_1_header_3\"><button class=\"accordion-button fs-6 fw-bold collapsed\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#kt_accordion_1_body_3\" aria-expanded=\"false\" aria-controls=\"kt_accordion_1_body_3\"> Cardholder Details </button></h2><div id=\"kt_accordion_1_body_3\" class=\"accordion-collapse collapse\" aria-labelledby=\"kt_accordion_1_header_3\" data-bs-parent=\"#kt_accordion_1\" style=\"\"><div class=\"accordion-body\"><div class=\"mb-0\"><span class=\"fs-7 text-gray-500\">Not Populated</span></div></div></div></div></div></div>", 1)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = { key: 6 }
const _hoisted_39 = { class: "rounded border pt-0 mb-5" }
const _hoisted_40 = {
  class: "accordion",
  id: "kt_accordion_1"
}
const _hoisted_41 = { class: "accordion-item" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "kt_accordion_1_header_1"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button fs-6 fw-bold",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#kt_accordion_1_body_1",
    "aria-expanded": "true",
    "aria-controls": "kt_accordion_1_body_1"
  }, " Order Details ")
], -1)
const _hoisted_43 = {
  id: "kt_accordion_1_body_1",
  class: "accordion-collapse collapse show",
  "aria-labelledby": "kt_accordion_1_header_1",
  "data-bs-parent": "#kt_accordion_1",
  style: {}
}
const _hoisted_44 = { class: "accordion-body" }
const _hoisted_45 = { class: "mb-0" }
const _hoisted_46 = { class: "accordion-item" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "kt_accordion_1_header_2"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button fs-6 fw-bold collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#kt_accordion_1_body_2",
    "aria-expanded": "false",
    "aria-controls": "kt_accordion_1_body_2"
  }, " Transaction Details ")
], -1)
const _hoisted_48 = {
  id: "kt_accordion_1_body_2",
  class: "accordion-collapse collapse",
  "aria-labelledby": "kt_accordion_1_header_2",
  "data-bs-parent": "#kt_accordion_1",
  style: {}
}
const _hoisted_49 = { class: "accordion-body" }
const _hoisted_50 = { class: "mb-0" }
const _hoisted_51 = { class: "accordion-item" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "kt_accordion_1_header_3"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button fs-6 fw-bold collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#kt_accordion_1_body_3",
    "aria-expanded": "false",
    "aria-controls": "kt_accordion_1_body_3"
  }, " Cardholder Details ")
], -1)
const _hoisted_53 = {
  id: "kt_accordion_1_body_3",
  class: "accordion-collapse collapse",
  "aria-labelledby": "kt_accordion_1_header_3",
  "data-bs-parent": "#kt_accordion_1",
  style: {}
}
const _hoisted_54 = { class: "accordion-body" }
const _hoisted_55 = { class: "mb-0" }
const _hoisted_56 = { class: "card card-flush mb-xl-10 pt-1" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "fw-bolder" }, "Chargeback Cycle")
  ])
], -1)
const _hoisted_58 = { class: "card-body h-auto pt-1" }
const _hoisted_59 = { class: "mb-0" }
const _hoisted_60 = { ref: "timelineRef" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NmiDetails = _resolveComponent("NmiDetails")!
  const _component_USAEPayDetails = _resolveComponent("USAEPayDetails")!
  const _component_SquareUp = _resolveComponent("SquareUp")!
  const _component_FluidPayDetails = _resolveComponent("FluidPayDetails")!
  const _component_NuveiDetails = _resolveComponent("NuveiDetails")!
  const _component_ReasonExplained = _resolveComponent("ReasonExplained")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("table", _hoisted_6, [
              _createElementVNode("tr", null, [
                _hoisted_7,
                _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.incoming.id), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_9,
                _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.incoming.case_number), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_11,
                _createElementVNode("td", _hoisted_12, [
                  _createTextVNode(" $" + _toDisplayString(_ctx.incoming.dispute_amount), 1),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.incoming.currency), 1)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_14,
                _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.incoming.dispute_date), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_16,
                _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.incoming.card.bin) + "******" + _toDisplayString(_ctx.incoming.card.last), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("table", _hoisted_19, [
              _createElementVNode("tr", null, [
                _hoisted_20,
                _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.incoming.expire_date), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_22,
                _createElementVNode("td", _hoisted_23, [
                  _createElementVNode("a", _hoisted_24, _toDisplayString(_ctx.incoming.reason), 1)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_25,
                _createElementVNode("td", _hoisted_26, [
                  _createTextVNode(_toDisplayString(_ctx.incoming.card.brand), 1),
                  _createElementVNode("span", null, [
                    (_ctx.incoming.card.brand == 'Visa')
                      ? (_openBlock(), _createElementBlock("img", _hoisted_27))
                      : _createCommentVNode("", true),
                    (_ctx.incoming.card.brand == 'Mastercard' || _ctx.incoming.card.brand == 'MasterCard')
                      ? (_openBlock(), _createElementBlock("img", _hoisted_28))
                      : _createCommentVNode("", true),
                    (
                      _ctx.incoming.card.brand == 'Amex' ||
                      _ctx.incoming.card.brand == 'AmericanExpress' ||
                      _ctx.incoming.card.brand == 'American Express'
                    )
                      ? (_openBlock(), _createElementBlock("img", _hoisted_29))
                      : _createCommentVNode("", true),
                    (_ctx.incoming.card.brand == 'Discover')
                      ? (_openBlock(), _createElementBlock("img", _hoisted_30))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_31,
                _createElementVNode("td", _hoisted_32, _toDisplayString(_ctx.incoming.transaction_date), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_33,
                _createElementVNode("td", _hoisted_34, _toDisplayString(_ctx.incoming.created), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.incoming.connection_id === '0')
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_37))
      : (_ctx.incoming.connection_id == '1')
        ? (_openBlock(), _createBlock(_component_NmiDetails, {
            key: 1,
            incoming: _ctx.incoming
          }, null, 8, ["incoming"]))
        : (_ctx.incoming.connection_id == '51')
          ? (_openBlock(), _createBlock(_component_USAEPayDetails, {
              key: 2,
              incoming: _ctx.incoming
            }, null, 8, ["incoming"]))
          : (_ctx.incoming.connection_id == '52')
            ? (_openBlock(), _createBlock(_component_SquareUp, {
                key: 3,
                incoming: _ctx.incoming
              }, null, 8, ["incoming"]))
            : (_ctx.incoming.connection_id == '45')
              ? (_openBlock(), _createBlock(_component_FluidPayDetails, {
                  key: 4,
                  incoming: _ctx.incoming
                }, null, 8, ["incoming"]))
              : (_ctx.incoming.connection_id == '56')
                ? (_openBlock(), _createBlock(_component_NuveiDetails, {
                    key: 5,
                    incoming: _ctx.incoming
                  }, null, 8, ["incoming"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _hoisted_42,
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                              _createElementVNode("div", _hoisted_45, [
                                _createElementVNode("h6", null, "Need to parse " + _toDisplayString(_ctx.incoming.connection_id), 1)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _hoisted_47,
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("div", _hoisted_50, [
                                _createElementVNode("h6", null, "Need to parse " + _toDisplayString(_ctx.incoming.connection_id), 1)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                          _hoisted_52,
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("div", _hoisted_55, [
                                _createElementVNode("h6", null, "Need to parse " + _toDisplayString(_ctx.incoming.connection_id), 1)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])),
    _createElementVNode("div", _hoisted_56, [
      _hoisted_57,
      _createElementVNode("div", _hoisted_58, [
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, null, 512)
        ])
      ])
    ]),
    _createVNode(_component_ReasonExplained, {
      reason_explained: _ctx.reason_explained,
      reason: _ctx.reason
    }, null, 8, ["reason_explained", "reason"])
  ], 64))
}